"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  gameWidth: 960,
  gameHeight: 600
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 345
// module chunks = 0